module.exports = __webpack_public_path__ + "img/Weapon_171.85337e6a.png";